import Axios from "axios";
import React, { useState } from "react";
import { AiFillDelete } from "react-icons/ai";

const SlotElement = ({ slot, competition, participants }) => {
    const [deleteDisabled, setDeleteDisabled] = useState(false);

    let phoneNo = competition.isTeamCompi
        ? participants.find((element) => element.mcTeamId === slot.userTeamId)
            ? participants.find(
                  (element) => element.mcTeamId === slot.userTeamId
              ).phone
            : ""
        : participants.find((element) => element.mrcId === slot.userTeamId)
        ? participants.find((element) => element.mrcId === slot.userTeamId)
              .phone
        : "";

    const deleteSlot = () => {
        setDeleteDisabled(true);
        Axios.post(
            "https://ashish.moodi.org/multicity/delete_slot",
            {
                mcpId: slot.mcpId,
                mcCompId: competition.mcId,
            },
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        )
            .then((res) => {
                if (res.data.status === "done") {
                    window.location.reload();
                }
            })
            .catch((err) => console.error(err));
    };

    return (
        <>
            <div className="row">
                <div className="col-sm-2">
                    {console.log(slot)}
                    {competition.isTeamCompi
                        ? participants.find(
                              (element) => element.mcTeamId === slot.userTeamId
                          )
                            ? participants.find(
                                  (element) =>
                                      element.mcTeamId === slot.userTeamId
                              ).MI_NO
                            : ""
                        : participants.find(
                              (element) => element.mrcId === slot.userTeamId
                          )
                        ? participants.find(
                              (element) => element.mrcId === slot.userTeamId
                          ).MI_NO
                        : ""}
                </div>
                <div className="col-sm-1"></div>
                <div className="col-sm-2">{slot.slotNumber}</div>
                <a href={`tel:${phoneNo}`} className="col-sm-3 ">
                    {phoneNo}
                </a>
                <div className="col-sm-1">
                    {deleteDisabled ? (
                        <div
                            class="spinner-border spinner-border-sm"
                            role="status"
                        >
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    ) : (
                        <AiFillDelete
                            color="red"
                            size={25}
                            style={{ cursor: "pointer" }}
                            onClick={deleteSlot}
                        />
                    )}
                </div>
            </div>
            <hr />
        </>
    );
};

export default SlotElement;
